import './App.css';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import Dashbord1 from './Components/Deshbord/Dashbord1';
import Login from './Components/Deshbord/Login';
import ManualOpretion from './Components/Sidbare/ManualOpretion';
import MemberReport from './Components/Sidbare/MemberReport';
import UserReport from './Components/UserReport/UserReport';
import StakingReport from './Components/UserReport/StakingReport';
import QrCodeAuth from './QrCodeAuth';
import ProtecteRoutes from './ProtecteRoutes';
import ManagePassword from './Components/Deshbord/ManagePassword';
import IconControl from './Components/Deshbord/IconControl';
import LevelRewardReport from './Components/UserReport/LevelRewardReport';
import ROiOfRoiReport from './Components/UserReport/ROiOfRoiReport';
import PendingWithdrwal from './Components/UserReport/PendingWithdrwal';
import StakingSidbarReport from './Components/Sidbare/StakingSidbarReport';
import LevelRewardSidbar from './Components/Sidbare/LevelRewardSidbar';
import PendingWithdrwalsidebar from './Components/Sidbare/PendingWithdrwalsidebar';
import WithdrwalSidebar from './Components/Sidbare/WithdrwalSidebar';
import Cron from './Cron';
import News from './Components/Sidbare/News';
import PoolSidebar from './Components/Sidbare/PoolSidebar';
import WeeklySidebar from './Components/Sidbare/WeeklySidebar';
import RoiofRoi from './Components/Sidbare/RoiofRoi';
import PoolReport from './Components/UserReport/PoolReport';
import Fifty from './Components/Pakeges/Fifty';
import Hundred from './Components/Pakeges/Hundred';
import Fivehundred from './Components/Pakeges/Fivehundred';
import Thousand from './Components/Pakeges/Thousand';
import Pool1 from './Components/Sidbare/Pool1';
import Pool2 from './Components/Sidbare/Pool2';
import Pool3 from './Components/Sidbare/Pool3';
import Pool4 from './Components/Sidbare/Pool4';
import Top1 from './Components/Sidbare/Top1';
import Pools from './Components/Sidbare/Pools';
import PendingDeposits from './Components/Sidbare/PendingDeposits';
import PrimeRewardReport from './Components/UserReport/PrimeRewardReport';
import PrimeReward from "./Components/Sidbare/PrimeReward"
import Deposits from './Components/Sidbare/Deposits';
import Top100 from './Components/Sidbare/Top100';
import Top1000 from './Components/Sidbare/Top1000';
import UserlistbyDate from './Components/Sidbare/UserlistbyDate';
import AdminDiposit from './Components/Sidbare/AdminDeposit';
// import QrCodeAuthWrapper from './Components/Sidbare/QrCodeAuthWrapper';
import UserBalanceReport from './Components/Sidbare/UserBalance';
import AdminPurchase from './Components/Sidbare/AdminPurchase';
import DepositWithdrawal from './Components/Sidbare/DepositWithdrawal';
import TicketsList from './Components/Sidbare/TicketsList';
import TicketChat from './Components/Sidbare/TicketChat';
import UserStructure from './Components/Sidbare/UserStructure';
import TeamWithdrawal from './Components/Sidbare/TeamWithdrawal';
import PendingWithdrwalsidebarDifferent from './Components/Sidbare/PendingWithdrwalsidebarDifferent';
import WithdrawalAddressApproval from './Components/Sidbare/WithdrawalAddressApproval';
import EcosystemSidbarReport from './Components/Sidbare/EcosystemSidbarReport';
import WithdrawalOpenApproval from './Components/Sidbare/WithdrawalOpenApproval';
import EcosystemReport from './Components/UserReport/EcosystemReport';
import BalanceReport from './Components/Sidbare/BalanceReport';
import TeamEcosystem from './Components/Sidbare/TeamEcosystem';
import UnblockMemberReport from './Components/Sidbare/UnblockMemberReport';
import BankReport from './Components/Sidbare/BankReport';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route path="/" element={<Login />} />
          <Route path="/authentication" element={<QrCodeAuth />} />

          <Route element={<ProtecteRoutes />}>
            <Route path="/dashbord" element={<Dashbord1 />} />
            <Route path="/manualop" element={<ManualOpretion />} />
            <Route path="/memberreport" element={<MemberReport />} />
            <Route path="/userreport/:username" element={<UserReport />} />

            {/* Sidebar Report */}
            <Route path="/stakingsidbarreport" element={<StakingSidbarReport />} />
            <Route path="/levelrewardsidbar" element={<LevelRewardSidbar />} />
            <Route path="/poolsidebar" element={<PoolSidebar />} />
            <Route path="/weeklysidebar" element={<WeeklySidebar />} />
            <Route path="/primesidebar" element={<PrimeReward />} />
            <Route path="/pools" element={<Pools />} />
            <Route path="/unblockmemberreport" element={<UnblockMemberReport />} />
            <Route path="/top1" element={<Top1 />} />
            <Route path="/top100" element={<Top100 />} />
            <Route path="/top1000" element={<Top1000 />} />
            <Route path="/userlistbyDate" element={<UserlistbyDate />} />
            <Route path="/userBalance" element={<UserBalanceReport />} />
            <Route path="/balancereport" element={<BalanceReport />} />
            <Route path="/bankreport" element={<BankReport />} />
            <Route path="/support" element={<TicketsList />} />
            <Route path="/support/:id" element={<TicketChat />} />
            <Route path="/teamecosystem" element={<TeamEcosystem />} />
            <Route path="/ecosystemsidbarreport" element={<EcosystemSidbarReport />} />
            <Route path="/ecosystemreport/:username" element={<EcosystemReport />} />

            {/* QrCodeAuthWrapper ensures QrCodeAuth runs before PendingWithdrwalsidebar */}
            <Route path="/pendingwithdrwalsidebar" element={<PendingWithdrwalsidebar />} />
               <Route path="/PendingWithdrwalsidebarDifferent" element={<PendingWithdrwalsidebarDifferent />} />
            <Route path="withdrwalsidebar" element={<WithdrwalSidebar />} />
            <Route path="/roiofroi" element={<RoiofRoi />} />
            <Route path="news" element={<News />} />
            <Route path="pendingdeposits" element={<PendingDeposits />} />
             <Route path="/withdrwalOpenApproval" element={<WithdrawalOpenApproval />} />
            <Route path="deposits" element={<Deposits />} />

            {/* Pool Menu */}
            <Route path="one" element={<Pool1 />} />
            <Route path="two" element={<Pool2 />} />
            <Route path="three" element={<Pool3 />} />
            <Route path="four" element={<Pool4 />} />

            {/* User Report */}
            <Route path="levelreport" element={<LevelRewardReport />} />
            <Route path="poolreport" element={<PoolReport />} />
            <Route path="roiofroireport" element={<ROiOfRoiReport />} />
            <Route path="pendingwithdrwal" element={<PendingWithdrwal />} />
            <Route path="primeReport" element={<PrimeRewardReport />} />
            <Route path="stakingreport" element={<StakingReport />} />

            {/* Packages */}
            <Route path="fifty" element={<Fifty />} />
            <Route path="hundred" element={<Hundred />} />
            <Route path="fivehundred" element={<Fivehundred />} />
            <Route path="thousand" element={<Thousand />} />

            {/* Admin Settings */}
            <Route path="managepassword" element={<ManagePassword />} />
            <Route path="iconcontrol" element={<IconControl />} />
            <Route path="cron" element={<Cron />} />
            <Route path="/adminDeposit" element={<AdminDiposit />} />
            <Route path="/adminpurchase" element={<AdminPurchase />} />
            <Route path='/depositWithdrawal' element={<DepositWithdrawal />} />
            <Route path="/userstructure" element={<UserStructure />} />
              <Route path="/teamclaim" element={<TeamWithdrawal />} />
            <Route path="/withdrawaladdressapproval" element={<WithdrawalAddressApproval />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
